export * from "modules/TyreDiscountsDashboard/components/DeleteTyreDiscountModal/hooks/useDeleteTyreDiscountMutation";
